
import './Body.css';
import React, {useState} from "react";
import Content from './Content.js';
import Header from './Header.js';
import Goals from './goals/Goals.js';
import Tasks from './tasks/Tasks.js';
import Sprint from './sprint/Sprint.js';
import Backend from './Backend.js';
import Profile from './Profile.js';
import workingBlocks from '../assets/constants/workingBlocks.js'
import { withAuthenticator } from '@aws-amplify/ui-react';


function Body(props) {
    const [activePage, setActivePage] = useState("content")
    const [activeBlock, setActiveBlock] = useState({startHour: 0, endHour: 0, workingBlock: workingBlocks[0], subtype: "unspecified"})
    const [userProfile, setUserProfile] = useState({
        "name": null,
        "pillars": [],
        "projects": [],
        "morningRoutineSteps": [],
        "eveningRoutineSteps": [],
        "tasks": [],
        "goals": [],
        "dates": [],
    })

    const pageMap = {
        "content": <Content isMobile={props.isMobile} userProfile={userProfile} setUserProfile={setUserProfile} activeBlock={activeBlock} setActiveBlock={setActiveBlock} />,
        "tasks": <Tasks userProfile={userProfile} setUserProfile={setUserProfile}/>,
        "goals": <Goals setActivePage={setActivePage} userProfile={userProfile} setUserProfile={setUserProfile}/>,
        "profile": <Profile setActivePage={setActivePage} userProfile={userProfile} setUserProfile={setUserProfile} />,
        "sprint": <Sprint userProfile={userProfile} setUserProfile={setUserProfile} />,
    }

    return (
        <div className="body">
            <Backend userProfile={userProfile} setUserProfile={setUserProfile}/>
            <Header activePage={activePage} setActivePage={setActivePage}/>
            {pageMap[activePage]}
        </div>
    )
}

export default withAuthenticator(Body);